exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contract-requests[data-v-9144c4a2] {\n  background: #EDEDED;\n}\n.contract-requests__table[data-v-9144c4a2] {\n  margin-top: 1.5rem;\n  border-radius: 2px;\n  -webkit-box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.08);\n          box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.08);\n}\n.contract-requests__view-details-btn[data-v-9144c4a2] {\n  float: right;\n}\n.contract-requests__no-contracts[data-v-9144c4a2] {\n  margin: 1rem auto;\n  text-align: center;\n}\n.contract-requests__btn-outer[data-v-9144c4a2] {\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9144c4a2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/contracts/index/requests/Contracts.RequestsList.vue
// module id = 8lUp
// module chunks = 1